import { Box, DialogContent } from '@mui/material';

import ResponsiveDialogActions from './ResponsiveDialogAction';
import { useDialogContext } from './dialog-context';
import { keyframes } from '@mui/system';

import QRCode from 'react-qr-code';

export const spin = keyframes`
    from {
      opacity: 0;
      transform: 'translateY(-10px)'
  }
    to {
      opacity: 1;
      transform: 'translateY(0)'
  }
  `;
export function QRCodeDialog({ value }) {
  const { closeDialog } = useDialogContext();
  return (
    <DialogContent sx={{ animation: `${spin} 400ms ease-out` }} dir="rtl">
      <Box sx={{ mt: 3 }} textAlign="center">
        <QRCode value={value} size={300} />
      </Box>
      <ResponsiveDialogActions onReject={closeDialog} singleAction />
    </DialogContent>
  );
}
